import React, {PropTypes} from 'react';

function Handset(props) {
  const {
    style: {
      color,
      backgroundColor
    } = {}
  } = props;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="14" viewBox="0 0 13 14">
        <path fill="none" fillRule="evenodd" stroke="#212225" d="M9.432 13.22l-.268-.046A2.613 2.613 0 0 1 8.648 13c-3.538-1.703-6.04-4.512-7.439-8.349C.64 3.087 1.26 1.66 2.751 1.1a1.429 1.429 0 0 1 1.067.008c.758.312 2.119 2.48 2.156 3.248.039.8-.519 1.222-.756 1.403-.14.106-.286.217-.094.7.412 1.034 1.101 1.786 2.109 2.296.101.052.15.054.16.054 0-.002.031-.028.07-.093.453-.767 1.005-.928 1.39-.928.394 0 .79.161 1.21.491l.17.133c.275.215.55.43.811.665l.141.123c.396.339 1.06.905.72 1.976-.311.988-1.38 2.046-2.473 2.046z"/>
    </svg>

  );
}

Handset.propTypes = {
  style: PropTypes.object
};

export default Handset;



// WEBPACK FOOTER //
// ./shared/common/svgs/Handset.js